import { AnchorAPI } from 'client/modules/AnchorAPI';
import { FetchVideoProcessingStatusParams } from 'client/modules/AnchorAPI/v3/upload/fetchVideoPreviewStatus';
import { useQuery } from 'react-query';

const FETCH_EPISODE_VIDEO_KEY = 'fetchEpisodeVideo';
const FETCH_VIDEO_PREVIEW_STATUS = 'fetchVideoPreviewStatus';

function useFetchEpisodeVideo({
  webEpisodeId,
  isEnabled,
}: {
  webEpisodeId?: string;
  isEnabled: boolean;
}) {
  return useQuery(
    [FETCH_EPISODE_VIDEO_KEY, webEpisodeId],
    () => {
      return AnchorAPI.fetchEpisodeVideo({ episodeId: webEpisodeId! });
    },
    // staleTime will default to 0 for now so we can ensure that we always refetch this query
    { enabled: !!webEpisodeId && isEnabled, staleTime: 0 }
  );
}

function useFetchVideoPreviewStatus({
  requestUuid,
}: Partial<FetchVideoProcessingStatusParams>) {
  return useQuery(
    [FETCH_VIDEO_PREVIEW_STATUS, requestUuid],
    () => {
      return AnchorAPI.fetchVideoPreviewStatus({ requestUuid: requestUuid! });
    },
    // staleTime will default to 0 for now so we can ensure that we always refetch this query
    { enabled: !!requestUuid, staleTime: 0 }
  );
}

export { useFetchEpisodeVideo, useFetchVideoPreviewStatus };
